import React, { useEffect, Suspense, lazy } from 'react';
import { Navbar } from './Navbar';
import { Hero } from './Hero';
import { Stats } from './Stats';
import { CountdownTimer } from './CountdownTimer';
const Testimonials = lazy(() => import('./Testimonials').then(m => ({
  default: m.Testimonials
})));
const ProblemSection = lazy(() => import('./ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const ProductHero = lazy(() => import('./ProductHero').then(m => ({
  default: m.ProductHero
})));
const Modules = lazy(() => import('./Modules').then(m => ({
  default: m.Modules
})));
const Bonuses = lazy(() => import('./Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('./Pricing').then(m => ({
  default: m.Pricing
})));
const FAQ = lazy(() => import('./FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./Footer').then(m => ({
  default: m.Footer
})));
const FloatingNotification = lazy(() => import('./FloatingNotification').then(m => ({
  default: m.FloatingNotification
})));
const WhatsAppFloat = lazy(() => import('./WhatsAppFloat').then(m => ({
  default: m.WhatsAppFloat
})));
import { CTAButton } from './CTAButton';
export function LandingPage() {
  useEffect(() => {
    // FB Pixel Init
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('init', '1313291250496067');
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen" data-id="element-79">
      <Navbar data-id="element-80" />
      <Hero data-id="element-81" />
      <Stats data-id="element-82" />
      <CountdownTimer data-id="element-83" />
      <Suspense fallback={null} data-id="element-84">
        <Testimonials data-id="element-85" />
        <ProblemSection data-id="element-86" />
        <ProductHero data-id="element-87" />
        <Modules data-id="element-88" />
        <Bonuses data-id="element-89" />
        <Pricing data-id="element-90" />

        {/* Guarantee Section */}
        <section className="bg-[#2D9B6F] py-8 md:py-12 text-center text-white" data-id="element-91">
          <div className="container mx-auto px-4" data-id="element-92">
            <div className="max-w-3xl mx-auto" data-id="element-93">
              <div className="text-6xl mb-4" data-id="element-94">🔒</div>
              <h2 className="font-poppins font-black text-3xl md:text-5xl mb-4" data-id="element-95">
                GARANTÍA DE 7 DÍAS
              </h2>
              <p className="text-xl leading-relaxed" data-id="element-96">
                Si abrís el pack y sentís que no es para vos, te devolvemos el
                100% de tu dinero. Sin preguntas, sin vueltas. Tu inversión está
                totalmente protegida.
              </p>
            </div>
          </div>
        </section>

        <FAQ data-id="element-97" />

        {/* Final CTA */}
        <section className="bg-[#1B3A6B] py-8 md:py-12 lg:py-[60px] text-center text-white" data-id="element-98">
          <div className="container mx-auto px-4" data-id="element-99">
            <h2 className="font-poppins font-black text-3xl md:text-6xl mb-5 md:mb-6 max-w-4xl mx-auto" data-id="element-100">
              ¿Lista/o para transformar la convivencia en tu escuela?
            </h2>
            <CTAButton href="#pricing" className="mx-auto" data-id="element-101">
              SÍ, QUIERO EL PACK COMPLETO
            </CTAButton>
          </div>
        </section>

        <Footer data-id="element-102" />
        <FloatingNotification data-id="element-103" />
        <WhatsAppFloat data-id="element-104" />
      </Suspense>
    </div>;
}